import { Component, OnInit, Input } from '@angular/core';
import { AppFeatures } from '@s8l/client-tree-lib';

import { CmsService } from 'src/app/services/cms.service';

@Component({
  selector: 'app-resource-icon',
  templateUrl: './resource-icon.component.html',
  styleUrls: ['./resource-icon.component.scss']
})
export class ResourceIconComponent implements OnInit {
  @Input() public resources;
  @Input() public size = 'sm';

  public get res() {
    const res = {};
    for (const r of this.resources) {
      res[r] = true;
    }
    return res;
  }

  constructor(private cms: CmsService) {}

  public hasFeature(feature: string) {
    return this.cms.hasFeatures([feature as AppFeatures]);
  }

  public ngOnInit() {}
}
